
export enum TemplateType {
	Default = "Default",
	Fraction = "Fraction",
	MultiStyleTextIcon = "MultiStyleTextIcon",
}

export enum TemplateTypeInConfig {
	Default = 'default',
	Fraction = 'fraction',
	MultiStyleTextIcon = 'multiStyleTextIcon'
}

export enum ColumnMode {
    standard = "standard",
    flex = "flex",
    force = "force",
}

export interface IPropAttributes {
	floatPrecision: number;
}

export interface ITemplateAttributes {
	upperThreshold: string;
	lowerThreshold: string;
}

export interface ScrollProperties {
	hasHorizontalScroll?: boolean;
	hasVerticalScroll?: boolean;
}

export interface ITableProperties {
	prop_attributes?: IPropAttributes;
	template_attributes?: ITemplateAttributes;
	scrollProperties?: ScrollProperties;
	sortable?: boolean;
}

export interface IGroupConfig {
	header: ITemplateConfig;
	group_size: number;
	sticky?: string;
}

export interface IGroupHeader {
	group: IGroupConfig[];
}

export interface IMinMaxWidth {
	width: number;
	minWidth?: number;
	maxWidth?: number;
}

export interface IWidthObject {
	relative_size: number;
	width_data: number | IMinMaxWidth;
}

export interface IValueObject {
	prop: string;
	floatPrecision: number;
	absoluteValue?: boolean;
}

export interface IThreshold {
	style: string;
	suffixIconClass?: string;
	prefixIconClass?: string;
	prefixClass?: string;
	suffixClass?: string;
}

export interface IThresholdStructure {
	value?: number;
	prop?: string;
	upper: IThreshold;
	lower: IThreshold;
}

export interface ITemplateParameters {
	threshold?: IThresholdStructure;
	suffixValue?: string;
	props?: object;
	denominatorStyle?: string;
}

export interface ITemplate {
	type: TemplateType;
	parameters: ITemplateParameters;
}

export interface ITemplateConfig {
	value?: string | IValueObject;
	style: string;
	template: ITemplate;
}

export interface IColumn {
	header: ITemplateConfig;
	cell: ITemplateConfig;
	width: IWidthObject;
}

export interface IColumnData {
	columns: IColumn[];
	column?: {
		freeze: {
			left?: number;
			right?: number;
		}
	};
	style?: {
		header?: string;
		cell?: string;
	}
}

export interface ISummary {
	data_path: string;
	templates: ITemplateConfig[];
}

export interface IRows {
	data_path: string;
	summary: ISummary;
}

export interface ITableConfig {
	table: ITableProperties;
	group_header?: IGroupHeader;
	column_data: IColumnData;
	rows: IRows;
}

export type TemplateValue = string | number;

export interface ICommonTableConfig {
	areGroupsVisible: boolean;
	columnsGrouping: TableColumn[];
	columns: TableColumn[];
	rows: IRows[];
	tableProperties: any;
	groupHeaderTableProperties: any;
	tableColumnMode: ColumnMode;
}
